import { useMutation, useQueryClient } from "@tanstack/react-query";
import axiosAuth from "../../../axiosAuth";
import { CRM_CLASS_DELETE } from "../../apiRoutes";
import { refreshAllCurriculumData } from "./curriculumRefresh";

export interface DeleteCrmClassResponse {
  message: string;
  success: boolean;
}

interface UseDeleteCrmClassMutationProps {
  onSuccess?: (data: DeleteCrmClassResponse) => void;
  onError?: (error: any) => void;
}

interface DeleteCrmClassRequest {
  classId: string;
  schoolId: string;
}

const deleteCrmClass = async ({
  classId,
}: DeleteCrmClassRequest): Promise<DeleteCrmClassResponse> => {
  const response = await axiosAuth.delete<DeleteCrmClassResponse>(
    `${CRM_CLASS_DELETE}${classId}/`
  );
  return response.data;
};

export const useDeleteCrmClassMutation = ({
  onSuccess,
  onError,
}: UseDeleteCrmClassMutationProps = {}) => {
  const queryClient = useQueryClient();

  return useMutation<DeleteCrmClassResponse, Error, DeleteCrmClassRequest>({
    mutationFn: deleteCrmClass,
    onSuccess: (data, variables) => {
      // Invalidate and refetch CRM class data
      queryClient.invalidateQueries({ queryKey: ["crm-class"] });
      // Refresh all curriculum data including grade management
      refreshAllCurriculumData(queryClient, variables.schoolId);
      onSuccess?.(data);
    },
    onError: (error) => {
      onError?.(error);
    },
  });
};
